<template>
	<div>{{coursePlanItems}}</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data () {
		return {

		}
	},
	mounted () {

    // this.$store.dispatch('fetchPersonTypes')
    // this.$store.dispatch('fetchCampus')
    // this.$store.dispatch('fetchFaculties')
    // this.$store.dispatch('fetchSubjects')
    // this.$store.dispatch('fetchAcademicYears')
    // this.$store.dispatch('fetchActiveCoursesByAcademicYear', 1)
    // this.$store.dispatch('fetchCoursePlansBySection', 2)

    
  },
  computed: {
    ...mapGetters([
    	'activeCourseItems', 
    	'courseTypeItems',
    	'sectionItems',
    	'coursePlanItems'
    	]),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/404.vue